import { useEffect, useState } from 'react'

export default function ThemeToggle() {
  const [dark, setDark] = useState(() =>
    localStorage.getItem('theme')
      ? localStorage.getItem('theme') === 'dark'
      : window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
  )

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark)
    localStorage.setItem('theme', dark ? 'dark' : 'light')
  }, [dark])

  return (
    <button
      onClick={() => setDark(d => !d)}
      className="btn-ghost rounded-xl"
      aria-label="Toggle theme"
      title={dark ? 'Switch to light theme' : 'Switch to dark theme'}
    >
      {dark ? '🌙 Dark' : '☀️ Light'}
    </button>
  )
}
